import { render, staticRenderFns } from "./requisitar-medicacao.vue?vue&type=template&id=1e71c6bf"
import script from "./requisitar-medicacao.vue?vue&type=script&lang=js"
export * from "./requisitar-medicacao.vue?vue&type=script&lang=js"
import style0 from "./requisitar-medicacao.vue?vue&type=style&index=0&id=1e71c6bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports